import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { QuoteViewerService } from "src/app/core/services/quote-viewer.service";

@Component({
	selector: "app-quote-viewer",
	templateUrl: "./quote-viewer.component.html",
	styleUrls: ["./quote-viewer.scss"],
})
export class QuoteViewerComponent implements OnInit {
	@ViewChild("focusQuote") focusQuote: ElementRef;
	constructor(private route: ActivatedRoute, public app: AppService, private titleService: Title, public quoteService: QuoteViewerService) {}

	ngOnInit(): void {
		this.titleService.setTitle(`Focus eQuote`);
		this.app.loading(true);
		const quoteId = this.route.snapshot.queryParamMap.get("id");

		this.quoteService.quote.subscribe((data) => {
			if (data?.Id) {
				this.app.loading(false);
				this.titleService.setTitle(`Focus eQuote for ${this.quoteService.quote.value.Opportunity.Account.Name}`);
				this.quoteService.logQuoteView(quoteId);
			}
		});
		this.quoteService.initQuote(quoteId);
	}
}
